import {
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import {PaginationButton} from './PaginationButton';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  top: number;
  skip: number;
  count: number;
  pages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  setSkip: (t: number) => void;
};
export function Pagination({
  top,
  skip,
  count,
  pages,
  hasNext,
  hasPrevious,
  setSkip,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <div
      {...props}
      className={clsx(className, 'flex flex-wrap items-center gap-x-2.5')}
    >
      <PaginationButton
        icon={faChevronDoubleLeft}
        disabled={!hasPrevious}
        onClick={() => setSkip(0)}
      />
      <PaginationButton
        icon={faChevronLeft}
        disabled={!hasPrevious}
        onClick={() => setSkip(skip - top)}
      />

      <span className="inline-block px-2 py-1">
        Page{' '}
        <strong>
          {Math.ceil(skip / top) + 1} of {Math.max(pages, 1)}
        </strong>
      </span>

      <PaginationButton
        icon={faChevronRight}
        disabled={!hasNext}
        onClick={() => setSkip(skip + top)}
      />
      <PaginationButton
        icon={faChevronDoubleRight}
        disabled={!hasNext}
        onClick={() => setSkip(top * (pages - 1))}
      />
    </div>
  );
}

Pagination.displayName = 'Pagination';
